/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import { Skeleton as LabSkeleton } from '@material-ui/lab'

export default function Skeleton(props) {
  return (
    <LabSkeleton {...props} />
  )
}
